export const FactionIcon = ({faction, style}) => {
    try {
        return <img src={require(`../assets/game/factions/${faction.toLowerCase()}.png`)} alt={faction} style={style}/>
    } catch (e) {
        console.log(e)
        return null
    }
}